import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "src/app/main/utilities/AgGridTable";
import DirectoryFilter from "../DirectoryFilter";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FormPageHeader from "../../../utilities/FormPageHeader";
import "../../expense-claim/expenseClaim.css";

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;
// const ActionRenderer = (props) => {
//   return (
//     <div className="flex item-center">
//       <Button color="warning" variant="contained" sx={{ mr: 1 }}>
//         View
//       </Button>
//       <Button color="warning" variant="contained" sx={{ mr: 1 }}>
//         {" "}
//         Edit
//       </Button>
//       <Button color="warning" variant="contained">
//         {" "}
//         Print
//       </Button>
//     </div>
//   );
// };
const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));
const payGroupOptions = [
  { label: "ALL", value: "ALL" },
  { label: "Nolte FZE", value: "Nolte FZE" },
  { label: "FREE LANCE", value: "FREE LANCE" },
  { label: "IT CONSULTANT", value: "IT CONSULTANT" },
];
const LoanDeduction = () => {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const navigate = useNavigate();

  const [rowData, setRowData] = useState([
    {
      code: "01",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "02",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "03",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
    {
      code: "04",
      empName: "Gokulnath",
      department: "IT Consultant",
      subDepartment: "Development",
      designation: "Software Engineer",
    },
  ]);
  const [columnDefs2, setColumnDefs2] = useState([
    {
      field: "date",
      headerName: "Loan Date",
      filter: "agNumberColumnFilter",
    },
    {
      field: "loanType",
      headerName: "Loan Type",
      // cellRenderer: PostingCheckboxRenderer,
    },
    {
      field: "loanAmount",
      headerName: "Loan Amount",
      // cellRenderer: InventoryCheckboxRenderer,
    },
    {
      field: "outstanding",
      headerName: "Outstanding",
      // cellRenderer: InventoryCheckboxRenderer,
    },
  ]);

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "date",
      headerName: "Date",
      filter: "agNumberColumnFilter",
    },
    {
      field: "loanType",
      headerName: "Loan Type",
      // cellRenderer: PostingCheckboxRenderer,
    },
    {
      field: "loanAmount",
      headerName: "Loan Amount",
      // cellRenderer: InventoryCheckboxRenderer,
    },
    {
      field: "installment",
      headerName: "Installment",
    },
    {
      field: "amountPaid",
      headerName: "Amount Paid",
    },
    {
      field: "outstanding",
      headerName: "Outstanding",
    },
    {
      field: "loanType",
      headerName: "Loan Type",
      // cellRenderer: PostingCheckboxRenderer,
    },
    {
      field: "loanAmount",
      headerName: "Loan AMount",
      // cellRenderer: InventoryCheckboxRenderer,
    },
    {
      field: "installment",
      headerName: "Installment",
    },
    {
      field: "amountPaid",
      headerName: "Amount Paid",
    },
    {
      field: "outstanding",
      headerName: "Outstanding",
    },
    {
      field: "Total Installment",
      headerName: "Total Installment",
    },
    {
      field: "Total Deducted",
      headerName: "Total Deducted",
    },
    {
      field: "Total Outstanding",
      headerName: "Total Outstanding",
    },
    // { headerName: "Action", cellRenderer: ActionRenderer, minWidth: 250 },
  ]);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(expenseListURL);
      // let expenseClaimList = list.data._embedded.expenses;
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);
  const onRowDoubleClicked = (params) => {
    navigate("/payroll/employee/profile");
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const getContextMenuItems = (event) => {
    var result = [
      {
        name: "View",
        icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
        action: (props) => {
          navigate(
            `/payroll/salary/revision/action?val=view&id=${event.node.data.code}`
          );
        },
      },
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: (props) => {
          navigate(
            `/payroll/salary/revision/action?val=edit&id=${event.node.data.code}`
          );
        },
      },
      {
        name: "Print",
        icon: '<span><i class="material-icons" style="font-size: 18px">print</i></span>',
        action: (props) => {
          // navigate(`/expense-claim/add?id=${event.node.data.id}`);
        },
      },

      // {
      //   name: "Delete",
      //   icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
      //   action: () => {
      //     onDelete(event);
      //   },
      // },
    ];
    return result;
  };
  return (
    <React.Fragment>
      <FormPageHeader
        componentName="List"
        pageName="Loan Deduction Report"
        currentPage="Loan Deduction Report"
      />

      <Stack
        direction={"row"}
        className={"items-end"}
        sx={{ padding: 2, paddingBottom: 0 }}
      >
        <Stack className="mr-16">
          Employee Name
          <StyledTextField
            type="text"
            className="w-[150px]"
            variant="outlined"
            name="year"
          />
        </Stack>

        <Button
          color="warning"
          variant="contained"
          startIcon={
            <FuseSvgIcon size={18}>heroicons-outline:search</FuseSvgIcon>
          }
          sx={{ mr: 1 }}
        />
      </Stack>
      <Stack sx={{ padding: 2 }}>
        <h3 className="mb-4">Against Payroll</h3>

        <AgGridTable
          hideCheckbox={true}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowData={rowData}
          rowGroupPanelShow="never"
          editable={false}
          pagination={false}
        />
      </Stack>
      <Stack sx={{ padding: 2, marginTop: 1 }}>
        <h3 className="mb-4">Against Bonus</h3>

        <AgGridTable
          hideCheckbox={true}
          columnDefs={columnDefs2}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowData={rowData}
          rowGroupPanelShow="never"
          editable={false}
          pagination={false}
        />
      </Stack>
      <Stack sx={{ padding: 2, marginTop: 1 }}>
        <h3 className="mb-4">Against Gratuity</h3>

        <AgGridTable
          hideCheckbox={true}
          columnDefs={columnDefs2}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowData={rowData}
          rowGroupPanelShow="never"
          editable={false}
          pagination={false}
        />
      </Stack>
      <Stack sx={{ padding: 1, margin: 2 }} direction={"row"}>
        <Stack sx={{ marginRight: 1 }}>Total Outstanding</Stack>
        <Stack>70,000.00</Stack>
      </Stack>
    </React.Fragment>
  );
};

export default LoanDeduction;
